import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import { FACEBOOK_PATH, INSTAGRAM_PATH } from "../../routing/paths";
import FillOrigamiStep from "../FillOrigamiStep";

const TWITTER_SPELL_NAME = "twitter";

const FillOrigamiStepProps = {
  previous: FACEBOOK_PATH,
  next: INSTAGRAM_PATH,
  question: "What's your <%= target %> profile URL",
  target: "Twitter",
  spellName: TWITTER_SPELL_NAME,
  placeholder: "username",
  required: false,
  prependValue: "https://twitter.com/",
};

export const TwitterStep: FunctionComponent<WizardProps> = (props: WizardProps) => (
  <FillOrigamiStep wizard={props} {...FillOrigamiStepProps} />
);

export default WizardContainer(TwitterStep);
